<template>
  <form class="v2-form-subscribe" @submit="submit">
    <app-overlay :show="busy">
      <div class="form-group">
        <input
          v-model="email"
          :placeholder="t('Email')"
          type="email"
          name="email"
          :required="true"
          class="form-control"
          :class="{ 'is-invalid': newsletterError }"
        />
        <div class="invalid-feedback text-center">
          {{ newsletterError }}
        </div>
        <button type="submit" class="btn btn-dark submit" :aria-label="`Subscribe`">
          <i class="icon icon-arrow-right" />
        </button>
      </div>
    </app-overlay>
    <app-overlay :show="subscribeDone" :no-wrap="true" :bg-enabled="true">
      <template #overlay>
        <div class="alert alert-success">
          {{ t("You have successfully subscribed!") }}
        </div>
      </template>
    </app-overlay>
  </form>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import FreeareaService from "@/api/services/freeareaService";
import AppOverlay from "@/components/v2/app-overlay";

defineOptions({
  name: "form-subscribe",
});

const { t } = useI18n();

const email = ref("");
const newsletterError = ref("");
const subscribeDone = ref(false);
const busy = ref(false);

const submit = async (e: Event) => {
  e.preventDefault();

  try {
    busy.value = true;
    newsletterError.value = "";

    await FreeareaService.subscribe(email.value);

    email.value = "";
    subscribeDone.value = true;

    setTimeout(() => {
      subscribeDone.value = false;
    }, 3000);
  } catch (e: any) {
    newsletterError.value = e.status.message || t("Something went wrong");
  } finally {
    busy.value = false;
  }
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
